"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _icon_props = require("./icon_props");

var _index = _interopRequireDefault(require("./svg/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Icon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _getPrototypeOf(Icon).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    } // 根据type获取对应图标的className

  }, {
    key: "getTypeClassName",
    value: function getTypeClassName() {
      var _this$props = this.props,
          type = _this$props.type,
          name = _this$props.name;
      var result = '';

      if (!name) {
        var needSpauiIconTypes = ['strongwarn', 'warn', 'success', 'confirm', 'tips', 'wrong', 'error', 'viewer', 'sort-asc', 'sort-desc'];
        var needGraphIconTypes = ['add', 'close', 'arrow-up', 'arrow-down', 'arrow-left', 'arrow-right', 'checkmark', 'delete'];
        result = (0, _classnames["default"])({
          'ico-strongwarn-mid': type === 'strongwarn',
          'ico-warn-mid': type === 'warn',
          'ico-success-mid': type === 'success',
          'ico-confirm-mid': type === 'confirm',
          'ico-tips-mid': type === 'tips',
          'ico-wrong-mid': type === 'wrong' || type === 'error',
          'graph-icon-add': type === 'add',
          'graph-icon-add graph-icon-close': type === 'close' || type === 'delete',
          'graph-icon graph-icon-line arrow-up': type === 'arrow-up',
          'graph-icon graph-icon-line arrow-down': type === 'arrow-down',
          'graph-icon graph-icon-line arrow-left': type === 'arrow-left',
          'graph-icon graph-icon-line arrow-right': type === 'arrow-right',
          'graph-icon graph-icon-line checkmark': type === 'checkmark',
          'spaui-icon-viewer': type === 'viewer',
          'spaui-icon-sort-asc': type === 'sort-asc',
          'spaui-icon-sort-desc': type === 'sort-desc',
          'spaui-icon': needSpauiIconTypes.includes(type),
          'graph-icon': needGraphIconTypes.includes(type)
        });
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          onMouseOver = _this$props2.onMouseOver,
          onMouseOut = _this$props2.onMouseOut,
          onMouseEnter = _this$props2.onMouseEnter,
          onMouseLeave = _this$props2.onMouseLeave,
          onMouseUp = _this$props2.onMouseUp;

      var _this$props3 = this.props,
          type = _this$props3.type,
          size = _this$props3.size,
          name = _this$props3.name,
          otherProps = _objectWithoutProperties(_this$props3, ["type", "size", "name"]); // 默认支持的操作事件


      var eventMap = {
        onClick: onClick,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp
      }; // 指定size的classname

      var sizeClassName = (0, _classnames["default"])({
        'size-sm': size === 'small',
        'size-lg': size === 'large',
        'size-xlg': size === 'extralarge'
      }); // 全局属性

      var theGlobalProps = (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(this.getTypeClassName(), sizeClassName),
        needTitle: true
      }, Icon);
      var result = null;
      var svgSize = '';
      var SvgComponent = null;

      if (_index["default"] && name && _index["default"][name]) {
        SvgComponent = _index["default"][name];
        delete theGlobalProps.ref;
        delete otherProps.htmlRef;
        delete otherProps.htmlref;
        result = _react["default"].createElement(SvgComponent, _extends({}, otherProps, theGlobalProps, eventMap));
      } else if (type === 'date') {
        // 日期图标svg
        result = _react["default"].createElement("svg", _extends({
          width: "17px",
          height: "17px",
          viewBox: "0 0 17 17"
        }, eventMap), _react["default"].createElement("path", {
          d: " M12,2 L12,0 L14,0 L14,2 L17,2 L17,3 L17,17 L0,17 L0,3 L0, 2 L3,2 L3,0 L5,0 L5,2 L12,2 Z M1,4 L1,16 L16,16 L16,4 L1, 4 Z M14,6 L14,8 L11,8 L11,6 L14,6 Z M10,6 L10,8 L7,8 L7, 6 L10,6 Z M14,9 L14,11 L11,11 L11,9 L14,9 Z M10,9 L10, 11 L7,11 L7,9 L10,9 Z M6,9 L6,11 L3,11 L3,9 L6,9 Z M14, 12 L14,14 L11,14 L11,12 L14,12 Z M10,12 L10,14 L7,14 L7, 12 L10,12 Z M6,12 L6,14 L3,14 L3,12 L6,12 Z ",
          id: "Combined-Shape",
          fill: "#B8BCC2",
          fillRule: "nonzero"
        }));
      } else if (type === 'delete_svg') {
        // 删除图标，支持设置大小
        if (size === 'small') {
          svgSize = '16px';
        } else if (size === 'large') {
          svgSize = '32px';
        } else {
          svgSize = '24px';
        }

        result = _react["default"].createElement("svg", _extends({
          width: svgSize,
          height: svgSize,
          viewBox: "0 0 16 16"
        }, eventMap), _react["default"].createElement("circle", {
          id: "Oval",
          fill: "#AAAFBA",
          fillRule: "evenodd",
          cx: "8",
          cy: "8",
          r: "8"
        }), _react["default"].createElement("path", {
          d: "M5.33333333,5.33333333 L10.6666667,10.6666667",
          id: "Line",
          stroke: "#FFFFFF",
          strokeWidth: "1",
          strokeLinecap: "square"
        }), _react["default"].createElement("path", {
          d: "M5.33333333,5.33333333 L10.6666667,10.6666667",
          id: "Line",
          stroke: "#FFFFFF",
          strokeWidth: "1",
          strokeLinecap: "square",
          transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) "
        }));
      } else if (type === 'add' || type === 'close') {
        // + 与 x
        result = _react["default"].createElement("i", _extends({}, theGlobalProps, eventMap), _react["default"].createElement("i", {
          className: "add-hor"
        }), _react["default"].createElement("i", {
          className: "add-ver"
        }));
      } else if (type === 'delete') {
        result = _react["default"].createElement("span", {
          className: "graph-icon-del ".concat(sizeClassName)
        }, _react["default"].createElement("i", _extends({}, theGlobalProps, eventMap), _react["default"].createElement("i", {
          className: "add-hor"
        }), _react["default"].createElement("i", {
          className: "add-ver"
        })));
      } else if (type === 'viewer' || type === 'sort-asc' || type === 'sort-desc') {
        // 这几个里面是没有<i></i>的
        result = _react["default"].createElement("i", _extends({}, theGlobalProps, eventMap));
      } else {
        // 默认的结构
        result = _react["default"].createElement("i", _extends({}, theGlobalProps, eventMap), _react["default"].createElement("i", null));
      }

      return result;
    }
  }]);

  return Icon;
}(_react.PureComponent); // 组件标记


_defineProperty(Icon, "propTypes", _icon_props.propTypes);

_defineProperty(Icon, "defaultProps", _icon_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Icon, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Icon;
exports["default"] = _default;